// components/admin/AdminSidebar.tsx
import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
  Tooltip,
  styled,
} from "@mui/material";
import {
  People,
  Business,
  BarChart,
  Settings,
  VideoLibrary,
  Workspaces,
  CreditCard,
  Insights,
  Assignment,
} from "@mui/icons-material";
import { THEME_COLORS } from "../../context/constants";

interface SidebarItem {
  text: string;
  icon: React.ReactNode;
  path: string;
  disabled?: boolean;
}

const sidebarItems: SidebarItem[] = [
  { text: "User Management", icon: <People />, path: "/admin-dashboard/users" },
  {
    text: "Workspaces",
    icon: <Workspaces />,
    path: "/admin-dashboard/workspaces",
    disabled: true,
  },
  {
    text: "Organizations",
    icon: <Business />,
    path: "/admin-dashboard/organizations",
  },
  {
    text: "Content",
    icon: <VideoLibrary />,
    path: "/admin-dashboard/content",
    disabled: true,
  },
  {
    text: "User Cost Analytics",
    icon: <CreditCard />,
    path: "/admin-dashboard/billing",
  },
  /*{
    text: "Plans Management",
    icon: <Assignment />,
    path: "/admin-dashboard/plans",
  },
  
  {
    text: "Analytics",
    icon: <BarChart />,
    path: "/admin-dashboard/analytics",
  },*/
  {
    text: "Feature Analytics",
    icon: <Insights />,
    path: "/admin-dashboard/feature-analytics",
  },
  {
    text: "Settings",
    icon: <Settings />,
    path: "/admin-dashboard/settings",
    disabled: true,
  },
];

const DisabledListItemButton = styled(ListItemButton)(({ theme }) => ({
  opacity: 0.5,
  pointerEvents: "none",
  "& .MuiListItemIcon-root, & .MuiListItemText-root": {
    color: theme.palette.text.disabled,
  },
}));

export const AdminSidebar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 2 }}>
      <Typography
        variant="h6"
        sx={{ mb: 2, px: 2, color: "white", cursor: "pointer" }}
        onClick={() => navigate("/admin-dashboard")}
      >
        Admin Dashboard
      </Typography>

      <Divider sx={{ borderColor: "rgba(255, 255, 255, 0.12)", mb: 2 }} />

      <List>
        {sidebarItems.map((item) => (
          <ListItem
            key={item.path}
            disablePadding
            sx={{
              mb: 0.5,
              "& .MuiListItemButton-root": {
                borderRadius: 1,
              },
              "& .Mui-selected": {
                backgroundColor: "rgba(255, 255, 255, 0.16)",
              },
              "& .Mui-selected:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.24)",
              },
            }}
          >
            {item.disabled ? (
              <Tooltip title="Coming soon" arrow>
                <DisabledListItemButton>
                  <ListItemIcon sx={{ color: "inherit" }}>{item.icon}</ListItemIcon>
                  <ListItemText
                    primary={item.text + " (soon)"}
                    primaryTypographyProps={{
                      fontWeight: "normal",
                    }}
                  />
                </DisabledListItemButton>
              </Tooltip>
            ) : (
              <NavLink
                to={item.path}
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  width: "100%",
                }}
              >
                <ListItemButton selected={location.pathname === item.path}>
                  <ListItemIcon sx={{ color: "white" }}>{item.icon}</ListItemIcon>
                  <ListItemText
                    primary={item.text}
                    primaryTypographyProps={{
                      fontWeight: location.pathname === item.path ? "bold" : "normal",
                    }}
                  />
                </ListItemButton>
              </NavLink>
            )}
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
